import { render } from "./CreatePostPopup.vue?vue&type=template&id=21bc0f49&scoped=true"
import script from "./CreatePostPopup.vue?vue&type=script&lang=js"
export * from "./CreatePostPopup.vue?vue&type=script&lang=js"

import "./CreatePostPopup.vue?vue&type=style&index=0&id=21bc0f49&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21bc0f49"]])

export default __exports__